import React from 'react';
import {
  Card, CardContent,
  CardHeader,
  Divider
} from '@material-ui/core';


export const MyCard = (props: any) => {
  return <Card>
    <CardHeader
      subheader={props.subTitle}
      title={props.title} />
    <Divider />
    <CardContent>
      {props.children}
    </CardContent>
    <Divider />

  </Card>;
};
